export const steps = {
   step_1: "step 1",
   step_2: "step 2",
   step_3: "step 3",
   step_4: "step 4",
};
